import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { PageHeader } from 'antd';
import { MyBreadcrumb } from 'utils';
import RackPhotoUpload from '../../components/RackPhotoUpload';
import { rackRegistryGetByIdService } from 'services/rackregistry';

const RackRegistryUpload = () => {
  const { id } = useParams();
  const [registry, setRegistry] = useState(null);

  useEffect(() => {
    const loadRegistryData = () => {
      rackRegistryGetByIdService(id)
        .then((response) => {
          if (response.data.items && response.data.items.length > 0) {
            setRegistry(response.data.items[0]);
          }
        })
        .catch((error) => {
          console.error('Failed to load rack registry details:', error);
        });
    };

    loadRegistryData();
  }, [id]);

  return (
    <div className="rack-registry-upload">
      <MyBreadcrumb
        items={[
          { label: 'Home', path: '/' },
          { label: 'Networking Dashboard', path: '/network-dashboard' },
          { label: 'Rack Registry', path: '/rackregistry' },
          { label: 'Upload Photos', path: '' },
        ]}
      />
      <PageHeader
        ghost={false}
        onBack={() => window.history.back()}
        title={`Rack Registry Photos - ${registry?.rack_name || 'Loading...'}`}
        subTitle=""
      >
        <RackPhotoUpload moduleType="rackRegistry" moduleId={id} />
      </PageHeader>
    </div>
  );
};

export default RackRegistryUpload;
